import React, { useState, useEffect, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../../common/SearchBar";
import { handleSearchBarFilter } from "./SitesPageUtils/handleSearchBarFilter";
import { useNavigate } from "react-router-dom";

export const GroupSearchBar = ({
  setSearchBarValue,
  setEditedParentGroupList,
  setBackdropLoadingScreenOn,
  searchBarValue,
}: {
  setSearchBarValue: any;
  setEditedParentGroupList: any;
  setBackdropLoadingScreenOn: any;
  searchBarValue: any;
}) => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState(searchBarValue);
  const pathnameRef = useRef(window.location.pathname);
  const didRunInitialSearch = useRef(false);
  const searchAbortRef = useRef<AbortController | null>(null);

  // Abort any search still in flight when the bar unmounts.
  useEffect(() => () => searchAbortRef.current?.abort(), []);

  useEffect(() => {
    // Only run if pathname hasn't changed
    if (pathnameRef.current === window.location.pathname) {
      const timer = setTimeout(() => {
        localStorage.setItem("siteSearchBarValue", inputValue);
        // Skip the group/?search= API call on initial mount when search is empty
        if (!didRunInitialSearch.current) {
          didRunInitialSearch.current = true;
          if ((inputValue ?? "").trim() === "") {
            setSearchBarValue(inputValue ?? "");
            return;
          }
        }
        // ENG-2682: one search in flight at a time; the newest one wins.
        searchAbortRef.current?.abort();
        const controller = new AbortController();
        searchAbortRef.current = controller;
        handleSearchBarFilter(
          inputValue, // Pass the input value directly
          setSearchBarValue,
          setEditedParentGroupList,
          navigate,
          setBackdropLoadingScreenOn,
          controller.signal
        );
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [
    inputValue,
    setSearchBarValue,
    setEditedParentGroupList,
    setBackdropLoadingScreenOn,
  ]);

  // Update pathname ref when it changes
  useEffect(() => {
    pathnameRef.current = window.location.pathname;
  }, [window.location.pathname]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    setLocalSearchBarValue(event.target.value);
  };

  const [localSearchBarValue, setLocalSearchBarValue] =
    useState(searchBarValue);

  React.useEffect(() => {
    setLocalSearchBarValue("");
  }, [window.location.pathname]);

  return (
    <Search>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        value={localSearchBarValue}
        placeholder="Search Groups..."
        onChange={handleChange}
        inputProps={{ "aria-label": "search" }}
      />
    </Search>
  );
};
